"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var config_1 = require("../config");

var index_1 = __importDefault(require("./MenuItem/index"));

var Menu =
/** @class */
function (_super) {
  __extends(Menu, _super);

  function Menu() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Menu.prototype.render = function () {
    var _a = this.props,
        active = _a.active,
        className = _a.className,
        onChange = _a.onChange;
    var b = config_1.block('menu');
    var index = 0;
    var items = this.props.items.map(function (item) {
      return react_1.default.createElement(index_1.default, __assign({}, item, {
        key: index++,
        active: active,
        onChange: onChange
      }));
    });
    return react_1.default.createElement("div", {
      className: b({}).mix(className)
    }, items);
  };

  Menu.defaultProps = {
    disabled: false,
    active: ''
  };
  return Menu;
}(react_1.Component);

exports.default = Menu;